import { useEffect, useState } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"


import classes from "./systemsettings.module.css"



const SystemSettings = () => {
  const [activeTab , setActiveTab] =useState("Currenciens")
  const navigate = useNavigate()
  const location = useLocation();


useEffect(()=>{
  const path = location.pathname.split("/systemsettings/").pop();

  setActiveTab(path)
},[location])
  const handleActiveTab =(tab ,route)=>{
    setActiveTab(tab)
    navigate(route)
  }
  return (
    <div className={classes.container}>
      <div className={classes.RowTabs}>
     {/* <NavTabs activeTab={activeTab} handleActiveTab={handleActiveTab} /> */}

      <div className={classes.TabsContent}>
    
       <Outlet />
      </div>
      </div>
     
    </div>
  )
}

export default SystemSettings